import { Record } from "immutable";

export class MarketDataRecord extends Record({
    id: null,
    state: null,
    business_division: null,
    company: null,
    create_date: null,
    modified_date: null,
    // is_active: null,
    total_sales: null,
    perc_share_of_product_in_overall_sales: null,
    perc_share_through_distribution_channel: null,
    total_no_distributor: null,
    total_no_retailers: null,
    territory_managed_by_distributor: null,
    no_of_retailer_or_sub_dealers_under_distribution: null,
    monthly_sale_for_anchor: null,
    yearly_sale_for_anchor: null,
    brands_dealing_in: [],
    no_of_brands_handled_by_distributor: null,
    name_of_brands_handled_by_distributor: null,
    region_categorization: null,
    credit_period_offered_by_distributor_days: null,
    any_overdue_gt_60_in_last_12_months: null,
    remarks_of_distributor: null,
    north: null,
    south: null,
    east: null,
    west: null,
    credit_period_offered_primary: null,
    credit_period_offered_secondary: null,
    cd_policy_primary: null,
    cd_policy_secondary: null,
    whether_channel_finance_is_there: false,
    sales_primary: null,
    sales_secondary: null,
    created_by: null,
    modified_by: null
}){}